<template>
  <div :style="{ height: pageHeight + 'px' }">
    <van-nav-bar
      fixed
      title="密码设置"
      left-text=""
      right-text=""
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <div class="mybox" :style="{ height: pageHeight+ 'px' }" style="margin-top:46px;">
      <van-form validate-first @failed="onFailed">
        <!-- 通过 pattern 进行正则校验 -->
        <van-field
          label="手机号"
          v-model="phone"
          name="pattern"
          placeholder="请输入正确手机号"
        />
        <van-field
        v-model="vscode"
        center
        clearable
        label="验证码"
        placeholder="请输入短信验证码"
      >
        <template #button>
          <van-button size="small" :disabled="disabled" type="info" @click="sendVscode">{{smsBtnTxt}}</van-button>
        </template>
      </van-field>
        <div style="margin: 16px 0;">
          <van-button  block type="info" native-type="submit" @click="onSubmit">确定</van-button>
        </div>
      </van-form>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Tabbar, TabbarItem, Col, Row, NavBar, Cell, CellGroup, Button, Form, Field } from 'vant'

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(Tabbar, TabbarItem, Col, Row, NavBar, Cell, CellGroup, Button, Form, Field)

export default {
  name: 'forgetPSWPage',
  components: {
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Col.name]: Col,
    [Row.name]: Row,
    [NavBar.name]: NavBar,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Button.name]: Button,
    [Form.name]: Form,
    [Field.name]: Field
  },
  created () {
    this.phone = this.$route.query.phoneNum
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)// 返回上一页面
      // this.$router.replace({
      //   path: '/login'// 到登录页
      // })
    },
    onClickRight () {

    },
    onFailed (errorInfo) {
      // console.log('failed', errorInfo)
    },
    // 倒计时
    startTimeDown (time) {
      let current = time
      let fun = () => {
        current--
        if (current <= 0) {
          this.disabled = false
          this.smsBtnTxt = '获取验证码'
        } else {
          this.disabled = true
          this.smsBtnTxt = current + ' 秒后重新获取'
          setTimeout(fun, 1000)
        }
      }

      fun()
    },
    // 发送验证码
    sendVscode () {
      // 不合法的手机号码
      // 不合法的手机号码
      if (!this.util.isPhoneNumber(this.phone)) {
        this.util.toast('请输入正确手机号')
        return
      }
      // 如果正在倒计时，不能继续发送。
      if (this.smsBtnTxt !== '获取验证码') { return }
      // 请求发短信接口。
      this.util.post('/updatePWByVerificationCode', {
        phoneNum: this.phone
      }).then(({ data }) => {
        if (data.code === 200) {
          this.util.toast(data.msg)
          // 开始倒计时。
          this.startTimeDown(60)
        } else {
          // this.util.toast(data.msg)
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    },
    onSubmit () {
      // 请求验证接口：
      this.util.post('/updatePWByQRVerificationCode', {
        phoneNum: this.phone,
        verificationCode: this.vscode
      }).then(({ data }) => {
        if (data.code === 200) {
          // 登录按钮执行登录的时候，存localStorage
          localStorage.setItem('isLogin', 1) // 存储已登录信息
          // localStorage.setItem('UserUpdatePWToken', data.data.UserUpdatePWToken)
          // 验证成功到密码设置页
          this.$router.push({ path: '/changepswPage', query: { phoneNum: this.phone, UserUpdatePWToken: data.data.UserUpdatePWToken } })
        } else {
          // 验证失败
          // this.util.toast(data.msg)
          return Promise.reject(new Error(data.message || data.msg || '系统错误，请稍后再试。'))
        }
      })
    }
  },
  computed: {},
  data () {
    return {
      phone: '',
      vscode: '',
      disabled: false, // 默认获取验证码可被点击
      smsBtnTxt: '获取验证码', // 发送验证码的提示文案。
      // pattern: /\d{6}/,
      pageHeight: window.innerHeight - 46
    }
  }
}
</script>

<style scoped lang="less">
/deep/.van-nav-bar__content {
  height: 46px;
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #A6A6A6;
}

</style>
